import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import PropTypes from "prop-types";
import { kebabCase } from "lodash";
import { FormGroup, HelpBlock } from "@icg360/ui-toolkit";
export var LAYOUT_TYPES = {
  DEFAULT: "DEFAULT",
  FULL: "FULL"
};
export var InputMeta = function InputMeta(_ref) {
  var _ref$controlProps = _ref.controlProps,
      controlProps = _ref$controlProps === void 0 ? {} : _ref$controlProps,
      Control = _ref.Control,
      label = _ref.label,
      _ref$validationErrors = _ref.validationErrors,
      validationErrors = _ref$validationErrors === void 0 ? [] : _ref$validationErrors,
      onChange = _ref.onChange,
      type = _ref.type,
      value = _ref.value;
  var id = kebabCase(label);
  var validationState;

  if (value && validationErrors.length > 0) {
    validationState = "error";
  }

  return /*#__PURE__*/React.createElement(FormGroup, {
    controlId: id,
    validationState: validationState
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "controlContainer",
    "data-bdd": "QTC " + label + " Input"
  }, /*#__PURE__*/React.createElement(Control, _extends({
    id: id,
    label: label,
    onChange: onChange,
    type: type,
    value: value
  }, controlProps)))), validationState === "error" && /*#__PURE__*/React.createElement("div", {
    className: "error-area"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inputLabel"
  }), /*#__PURE__*/React.createElement("div", {
    className: "controlContainer"
  }, validationErrors.map(function (error) {
    return /*#__PURE__*/React.createElement(HelpBlock, {
      key: error.message
    }, createErrorMessage(error, type));
  })), /*#__PURE__*/React.createElement("div", {
    className: "supportIcon"
  })));
};
InputMeta.LAYOUT_TYPES = LAYOUT_TYPES;
InputMeta.propTypes = {
  Control: PropTypes.func,
  controlProps: PropTypes.object,
  label: PropTypes.string,
  onChange: PropTypes.func,
  passthroughProps: PropTypes.shape({
    saveQuote: PropTypes.func
  }),
  type: PropTypes.string,
  validationErrors: PropTypes.arrayOf(PropTypes.shape({
    message: PropTypes.string
  })),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
export var InputMetaWrapper = function InputMetaWrapper(Control, overwriteProps) {
  if (overwriteProps === void 0) {
    overwriteProps = {};
  }

  var Renderer = function Renderer(props) {
    return /*#__PURE__*/React.createElement(InputMeta, _extends({}, props, overwriteProps, {
      Control: Control
    }));
  };

  Object.defineProperty(Renderer, "name", {
    value: Control.name + "(InputMetaRenderer)"
  });
  return Renderer;
};

function createErrorMessage(_ref2) {
  var message = _ref2.message,
      customMessage = _ref2.customMessage;
  if (customMessage) return customMessage;
  return message;
}